import { ADD_AUDIT_MESSAGES,SHOW_AUDIT_MESSAGE_LIST } from './actionTypes';

export function addAuditMessages(auditorMessages) {
    return {
        type: ADD_AUDIT_MESSAGES,
        auditorMessages
    };
}

export function setMessageListVisibility(isMessageListOpen) {
    return {
        type: SHOW_AUDIT_MESSAGE_LIST,
        isMessageListOpen
    };
}